import { useMemo } from 'react';

import { useClusters } from '@cast/shared-cluster-context-data-access';
import { K8sProvider } from '@cast/shared-types';

import { useIsClusterDemoMode } from '@cast/infrastructure-demo';

export const useOrgHasClustersWithProvider = (
  provider: `${K8sProvider}` | Array<`${K8sProvider}`>
) => {
  const { clusters } = useClusters();
  const isClusterDemoMode = useIsClusterDemoMode();
  return useMemo(() => {
    if (isClusterDemoMode) {
      return false;
    }

    if (Array.isArray(provider)) {
      return clusters.some((cluster) =>
        provider.some((provider) => cluster.providerType === provider)
      );
    } else {
      return clusters.some((cluster) => cluster.providerType === provider);
    }
  }, [provider, clusters, isClusterDemoMode]);
};
